import { apiSlice } from "../api/apiSlice";

export const assignmentsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAssignments: builder.query({
      query: () => "/assignments",
    }),
    getAssignment: builder.query({
      query: (video_id) => `/assignments?video_id=${video_id}`,
    }),
    createAssignment: builder.mutation({
      query: (data) => ({
        url: "/assignments",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const result = await queryFulfilled;
          if (result?.data?.id) {
            // passimistically update the assignments
            dispatch(
              apiSlice.util.updateQueryData(
                "getAssignments",
                undefined,
                (data) => {
                  data.push(result.data);
                }
              )
            );
          }
        } catch (err) {
          console.log(err);
        }
      },
    }),
    updateAssignment: builder.mutation({
      query: (data) => ({
        url: `/assignments/${data.id}`,
        method: "PATCH",
        body: data,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const result = await queryFulfilled;
          if (result?.data?.id) {
            // passimistically update the Assignments
            dispatch(
              apiSlice.util.updateQueryData(
                "getAssignments",
                undefined,
                (draft) => {
                  const assignment = draft.find(
                    (video) => video.id === result.data.id
                  );
                  assignment.title = result.data.title;
                  assignment.video_id = result.data.video_id;
                  assignment.video_title = result.data.video_title;
                  assignment.totalMark = result.data.totalMark;
                }
              )
            );
          }
        } catch (err) {
          console.log(err);
        }
      },
    }),
    deleteAssignment: builder.mutation({
      query: (assignmentId) => ({
        url: `/assignments/${assignmentId}`,
        method: "DELETE",
      }),
      async onQueryStarted(assignmentId, { dispatch, queryFulfilled }) {
        try {
          const result = await queryFulfilled;
          if (result?.meta?.response?.status === 200) {
            // passimistically delete the assignment
            dispatch(
              apiSlice.util.updateQueryData(
                "getAssignments",
                undefined,
                (drafts) => {
                  // eslint-disable-next-line eqeqeq
                  const deletedAssignment = drafts.filter(
                    (assignment) => assignment.id !== assignmentId
                  );
                  return deletedAssignment;
                }
              )
            );
          }
        } catch (err) {
          console.log(err);
        }
      },
    }),
  }),
});

export const {
  useGetAssignmentsQuery,
  useGetAssignmentQuery,
  useCreateAssignmentMutation,
  useUpdateAssignmentMutation,
  useDeleteAssignmentMutation,
} = assignmentsApi;
